import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { setMarket, setRunner, setIsBack, setPrice, setPriceActual, setStake, setDelay, setMtype, setBtype, setLine, setRunnerName, setEventName, setShowBetPlacingPopover, setBetPlacingPopoverStage, setFromOneClick } from '../../../store/betPlacing/betPlacing.slice'
import { requestBetPlacingStart } from '../../../store/betPlacing/betPlacing.thunks'
import { requestExchangeGames } from '../../../store/exchangeGames/exchangeGames.thunks'


export const connectSicbo = (wrappedProps) => (component) => {
  function mapStateToProps(state) {
    return {
      betPlacing: state.betPlacing,
      exchangeGames: state.exchangeGames,
      balanceSettings: state.balanceSettings,
      sportEvent: state.sportEvent,
      exposure: state.eventPage.exposure,
      oneClick: state.user.settings.oneClickSettings,
      // oneClick: state.user.settings.oneClickSettings.active,
      sportEventStats: state.sportEvent.sportStats,
      openBets: state.openBets,
      presetStakeSettings: state.user.settings.presetStakeSettings,
      lastResultsExch: state.lastResultsExch,
      headerHeight: state.elementsParams.headerHeight,
      auth: state.auth,
      elementsParams: state.elementsParams
    }
  }

  function mapDispatchToProps(dispatch) {
    const actions = {
      setMarket,
      setRunner,
      setRunnerName,
      setEventName,
      setIsBack,
      setPrice,
      setPriceActual,
      setDelay,
      setStake,
      setMtype,
      setBtype,
      setLine,
      setShowBetPlacingPopover,
      setBetPlacingPopoverStage,
      setFromOneClick,
      requestBetPlacingStart,
      requestExchangeGames
    }

    return { actions: bindActionCreators(actions, dispatch) }
  }
  return connect(mapStateToProps, mapDispatchToProps)(component)
}
